// extracted by mini-css-extract-plugin
export default {"button":"Pagination_button__aDJGj","editLayer":"Pagination_editLayer__OJfjY","prev":"Pagination_prev__uYOBB","next":"Pagination_next__l84KI"};